import { styled, Badge, ButtonBase } from "@mui/material";
import { type ReactNode } from "react";

import type { ButtonProps } from "@/components/Button";

const StyledButton = styled(ButtonBase)(() => ({
  flexDirection: "column",
  gap: "calc(var(--spacing)*2)",
  color: "var(--color-text-interactive)",
  fontWeight: "500",
  fontSize: "14px",
  letterSpacing: "0",
  lineHeight: "20px",
  borderRadius: "var(--radius-2xl)",
  padding: "calc(var(--spacing)*2)",
  width: "80px",
  backgroundColor: "var(--color-white)",
  transition: "transform 0.2s ease-in-out",
  "&:hover": {
    transform: "scale(1.05)",
  },
}));

type SearchNavigationButtonProps = {
  badgeContent?: ReactNode;
} & ButtonProps;

export const SearchNavigationButton = ({
  badgeContent,
  children,
  ...buttonProps
}: SearchNavigationButtonProps) => {
  const button = <StyledButton {...buttonProps}>{children}</StyledButton>;

  if (!badgeContent) return button;

  return (
    <Badge
      color="primary"
      badgeContent={badgeContent}
      sx={{
        ".MuiBadge-badge": {
          background: "linear-gradient(103deg, #93FFD4 0%, #0F9 100%)",
          px: "calc(var(--spacing)*2)",
          py: "calc(var(--spacing)*0.5)",
          color: "var(--color-text-interactive)",
          fontWeight: 400,
          fontSize: "var(--text-xs)",
          lineHeight: "var(--tw-leading, var(--text-xs--line-height))",
          height: "auto",
        },
      }}
    >
      {button}
    </Badge>
  );
};
